import Decimal from "decimal.js";
import { ObjectPlugin } from "vue";

const capitaliseEach = (val: string) => {
  return val
    .replaceAll("_", " ")
    .replaceAll("-", " ")
    .split(" ")
    .map(function (a) {
      return a.charAt(0).toUpperCase() + a.slice(1);
    })
    .join(" ");
};

const formatterDecimal = new Intl.NumberFormat("en-AU", {
  style: "decimal",
  currency: "AUD",
  minimumFractionDigits: 2, // Minimum Decimal Place
  maximumFractionDigits: 2, // Maximum Decimal Place
});
const decimal = (
  val: null | Decimal | number,
  ifnull: string | null = "0.00"
) => {
  if (val === null) {
    return ifnull;
  } else if (val instanceof Decimal) {
    return formatterDecimal.format(val.toNumber());
  } else {
    return formatterDecimal.format(val);
  }
};

const formatterCurrency = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  minimumFractionDigits: 2, // Minimum Decimal Place
  maximumFractionDigits: 2, // Maximum Decimal Place
});

const currency = (val: null | Decimal, ifnull: string = "$0.00") => {
  if (val === null) {
    return ifnull;
  } else {
    return formatterCurrency.format(val.toNumber());
  }
};

const formatPlugin = () => {
  return { capitaliseEach, decimal, currency } as const;
};
export type FormatPlugin = ReturnType<typeof formatPlugin>;

export const $format: ObjectPlugin = {
  install: (app, _) => {
    app.config.globalProperties.$format = formatPlugin();
  },
};

export default $format;
